import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "50",
  viewBox: "0 0 50 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M25 0C11.23 0 0 11.23 0 25c0 12.043 9.553 25 25 25 13.77 0 25-11.23 25-25S38.77 0 25 0zm1.778 34.654h-3.556v-3.557h3.557l-.003 3.557zm0-6.504h-3.556V15.345h3.557l-.003 12.805z"
  })]
});